import React, { useEffect, useRef, useState } from 'react';
import { Pressable } from 'react-native';
import { BottomSheet, Label, RadioButton, Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
function OptInOutModal({ previousState, negativeOption, positiveOption, isOpen, setIsOpen, handleUpdate, }) {
    const [optState, setOptState] = useState(previousState);
    const isUpdatedDisabled = previousState === optState;
    const isAccepted = optState === 'accept';
    const isDeclined = optState === 'decline';
    const ref = useRef(null);
    useEffect(() => {
        setOptState(previousState);
    }, [previousState, isOpen]);
    const handleClose = () => {
        setIsOpen(false);
    };
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.dismiss();
        }
    }, [isOpen]);
    return (React.createElement(BottomSheet, { ref: ref, enableDynamicSizing: true, topNavigationProps: {
            title: i18n.t('Global.microcopy.common.status'),
            buttonStart: {
                element: i18n.t('Global.microcopy.common.cancel'),
                onPress: handleClose,
                label: i18n.t('Global.microcopy.common.cancel'),
            },
            buttonEnd: {
                element: i18n.t('Global.microcopy.common.update'),
                onPress: () => handleUpdate(optState),
                label: i18n.t('Global.microcopy.common.update'),
                disabled: isUpdatedDisabled,
            },
        }, onBackdropClick: handleClose, onDismiss: handleClose, testID: "OptInOutModal" },
        React.createElement(Stack, { flexDirection: "column", gap: "$4", marginBottom: "$4" },
            React.createElement(RadioButton, { selected: isAccepted, label: i18n.t(positiveOption), onPress: () => setOptState('accept'), testID: positiveOption }),
            React.createElement(RadioButton, { selected: isDeclined, label: i18n.t(negativeOption), onPress: () => setOptState('decline'), testID: negativeOption }))));
}
function OptInOut({ handleConsent, initialState, optionStrings, onDecline }) {
    const [optState, setOptState] = useState(initialState);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        setOptState(initialState);
    }, [initialState]);
    const handleUpdate = async (state) => {
        if (optState === state) {
            return;
        }
        if (state === 'decline' && onDecline) {
            onDecline();
            setIsOpen(false);
            return;
        }
        try {
            await handleConsent(state);
            setOptState(state);
            setIsOpen(false);
        }
        catch (error) {
            log.error(error);
        }
    };
    const isAccepted = optState === 'accept';
    const { negativeOption, negativeTag, positiveOption, positiveTag, titleTag } = optionStrings;
    return (React.createElement(Stack, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "$4" },
        React.createElement(Stack, { display: "flex", flexDirection: "row", alignItems: "center", gap: "$2" },
            React.createElement(Text, { type: "$bodyBase.medium", color: "$text.100", nativeID: titleTag, testID: titleTag },
                i18n.t(titleTag),
                ":"),
            React.createElement(Label, { "aria-label": isAccepted ? i18n.t(positiveTag) : i18n.t(negativeTag), type: isAccepted ? 'success' : 'generic' },
                React.createElement(Label.Text, { testID: isAccepted ? positiveTag : negativeTag, nativeID: isAccepted ? positiveTag : negativeTag }, isAccepted ? i18n.t(positiveTag) : i18n.t(negativeTag)))),
        React.createElement(Pressable, { nativeID: "Global.microcopy.common.update", testID: "Global.microcopy.common.update", onPress: () => setIsOpen(true) },
            React.createElement(Text, { type: "$bodyBase.medium", color: "$interactive.core.enabled" }, i18n.t('Global.microcopy.common.update'))),
        React.createElement(OptInOutModal, { negativeOption: negativeOption, positiveOption: positiveOption, handleUpdate: handleUpdate, previousState: optState, isOpen: isOpen, setIsOpen: setIsOpen })));
}
export { OptInOut };
